import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {getSmscType, IRouteConfig} from '../_model'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import RouteActionCell from '../components/RouteActionCell'
import {getSmsType} from '../../SMSBroadCast/core/helper'

const routesListColumn = (
  handleSelect: (selectType: string, id: number) => void
): ReadonlyArray<Column<IRouteConfig>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IRouteConfig>>) => (
      <CustomHeader tableProps={props} title='Route name' className='min-w-100px' />
    ),
    id: 'name',
    accessor: 'name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IRouteConfig>>) => (
      <CustomHeader tableProps={props} title='user name' className='min-w-100px' />
    ),
    id: 'useridparam',
    accessor: 'useridparam',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IRouteConfig>>) => (
      <CustomHeader tableProps={props} title='SMSC Type' className='min-w-100px' />
    ),
    id: 'smsctype',
    // accessor: 'smsctype',
    Cell: ({...props}) => <span>{getSmscType(props.data[props.row.index].smsctype)}</span>,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IRouteConfig>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <RouteActionCell selectItem={handleSelect} id={props.data[props.row.index].id} />
    ),
  },
]

export default routesListColumn
